import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { ProductsListResponse, StripeProduct } from "./types";

export const CATALOG_PRODUCTS_QUERY_KEY = ["admin", "catalog", "products"] as const;

// Hand-written fetch — see CLAUDE.md → TD-07 for why we bypass the
// Orval-generated client and call `httpClient` directly.
async function fetchProducts(): Promise<readonly StripeProduct[]> {
  const res = await httpClient<ProductsListResponse>("/api/admin/catalog/products");
  return res.items;
}

export function useProductsList() {
  return useQuery({
    queryKey: CATALOG_PRODUCTS_QUERY_KEY,
    queryFn: fetchProducts,
    staleTime: 60_000,
  });
}
